import MainLayout from "@/layouts/MainLayout.vue";
import UserSpaces from "@/views/Main/UserSpaces.vue";

import LicencePrivate from "@/views/Main/LicencePrivat.vue";
import ProfileView from "@/views/Main/ProfileView.vue";
import CreateOrganization from "@/views/Main/Organization/CreateOrganization.vue";
import EditOrganization from "@/views/Main/Organization/EditOrganization.vue";

const baseDataRoutes = [
  {
    path: "/",
    name: "main",
    component: MainLayout,
    // params: { nodeId: "locations" },
    children: [
      {
        path: "",
        name: "user-spaces",
        component: UserSpaces
      },
      {
        path: "licence/private",
        name: "licence-private",
        component: LicencePrivate
      },
      {
        path: "profile",
        name: "profile",
        component: ProfileView
      },
      {
        path: "organization/create",
        name: "organization-create",
        component: CreateOrganization
      },
      {
        path: "organization/:id",
        name: "organization",
        component: EditOrganization
      }
    ]
  }
];
export default baseDataRoutes;
